import type { CreditPackage } from "@app/analytics/account/Billing/types";
import * as Events from "@app/analytics/tracking/events";
import ROUTES from "@app/common/routes";
import { withQueryParamsUrl } from "@app/common/utils";
import Config from "@app/config";

import BillingPurchaseForm, {
  BillingPurchaseFormProps,
} from "../BillingPurchaseForm";

type BillingCreditCheckoutPurchaseProps = Omit<
  BillingPurchaseFormProps,
  "onPurchase" | "paymentConfirmReturnUrl" | "submitCta"
> & { selectedPackage: CreditPackage };

const BillingCreditCheckoutPurchase = ({
  selectedPackage,
  ...props
}: BillingCreditCheckoutPurchaseProps) => {
  const handlePurchase = () =>
    Events.purchaseCredits({ quantity: selectedPackage.quantity });

  const paymentConfirmReturnUrl = withQueryParamsUrl(
    Config.stripe.creditCheckoutReturnUrl,
    {
      quantity: selectedPackage.quantity,
      redirect_to: `${Config.FRONTEND_URL}${ROUTES.BILLING}?from=credit_purchase`,
    }
  );

  return (
    <BillingPurchaseForm
      onPurchase={handlePurchase}
      paymentConfirmReturnUrl={paymentConfirmReturnUrl}
      submitCta="Purchase"
      {...props}
    />
  );
};

export default BillingCreditCheckoutPurchase;
